/**
 * @fileoverview Domain grid layout component
 * @module TechStackAnalysis/components/DomainGrid
 */

import React from 'react';
import DomainCard from './DomainCard';

/**
 * Domain grid component - responsive 1/2/3 column layout
 * @param {Object} props
 * @param {Array} props.domains - Array of domain objects
 * @param {Object} props.selectedVendor - Currently selected vendor
 * @param {Function} props.onVendorClick - Vendor click handler
 * @param {Function} props.onHaptic - Haptic feedback trigger
 */
const DomainGrid = ({ domains, selectedVendor, onVendorClick, onHaptic }) => {
  if (!domains || domains.length === 0) {
    return (
      <div className="ts-empty-domain" style={{ padding: '40px', textAlign: 'center' }}>
        No domain data available
      </div>
    );
  }

  return (
    <div className="ts-domain-grid">
      {domains.map((domain, index) => (
        <DomainCard
          key={domain.code || index}
          domain={domain}
          selectedVendor={selectedVendor}
          onVendorClick={onVendorClick}
          onHaptic={onHaptic}
        />
      ))}
    </div>
  );
};

export default DomainGrid;
